import GetReadingMaterial from "./page/GetReadingMaterial";

interface ReadingMaterialProps {
  onClose: () => void;
  videoId: string
}

const ReadingMaterial: React.FC<ReadingMaterialProps> = ({
onClose,
videoId
}) => {
  return (
    <GetReadingMaterial onClose={onClose} videoId={videoId}/>
  );
};

export default ReadingMaterial;
